export function typing(el: HTMLElement, content: string) {
    let charIndex = 0;
    el.innerHTML = '';

    function getRandom(min: number, max: number): number {
        return Math.floor(Math.random() * (max - min) + min);
    }

    function nextChar() {
        setTimeout(function () {
            el.innerHTML += content[charIndex++];
            if (charIndex < content.length) nextChar();
        }, getRandom(50, 200));
    }

    nextChar();
}

export function activateTypingAnimations() {
    for (const el of document.querySelectorAll<HTMLElement>('.typing-animation-target')) {
        const content = el.dataset.animationContent;
        if (content) {
            typing(el, content);
        }
    }
}
